import { GivelifyIcon } from '@givelify/givelify-ui';
import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
});

export const StyledIcon = styled(GivelifyIcon)({
    maxWidth: 244,
    maxHeight: 139,
    width: '100%',
    height: '100%',
    marginBottom: 32,
});

export const StyledText = styled('div')(({ theme }) => ({
    marginBottom: 40,
    color: theme.legacy.colors.neutralGrey,
}));
